export const TOAST_TYPES = {
  error: "error",
  info: "info",
  success: "success",
};
